import { httpRequest } from "@services/http";

export class CommandDeleteFeature {
  async run(featureId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/features/${featureId}`;
    try {
      await httpRequest(url, { method: "DELETE" });
    } catch (error) {
      console.error("Error deleting feature:", error);
      throw error;
    }
  }
}
